import './index.scss';
import { DropdownSearch } from 'ii-react-sdk/form_components';
import React, { useState } from 'react';
import { useUser } from '~/providers/user';
const OrgSwitcher = () => {
    const { activeOrganization, switchOrganization, organizations, } = useUser();
    const [filteredOrgs, setFilteredOrgs] = useState(organizations);
    const titleIcon = (React.createElement("div", { className: 'active-org', "data-public": true },
        React.createElement("i", { className: 'fas fa-building menu-icon' }),
        "\u00A0",
        React.createElement("div", { className: 'org-name overflow-ellipsis' }, activeOrganization === null || activeOrganization === void 0 ? void 0 : activeOrganization.name)));
    if ((organizations === null || organizations === void 0 ? void 0 : organizations.length) <= 1) {
        return React.createElement("div", { className: 'org-switcher single-org' }, titleIcon);
    }
    const onOrgSelected = (org) => {
        if (org === (activeOrganization === null || activeOrganization === void 0 ? void 0 : activeOrganization.name))
            return;
        const newOrg = organizations.find(o => o.name === org);
        if (newOrg)
            switchOrganization(newOrg);
    };
    const onOrgSearch = (searchText) => {
        if (!searchText) {
            setFilteredOrgs(organizations);
            return;
        }
        setFilteredOrgs(organizations.filter(o => o.name.toLowerCase().includes(searchText.toLowerCase())));
    };
    return (React.createElement("div", { className: 'org-switcher', "data-public": true },
        React.createElement(DropdownSearch, { className: 'org-picker', items: filteredOrgs.map(o => o.name), onSelectCallback: onOrgSelected, onSearchCallback: onOrgSearch, selectedItems: activeOrganization ? [activeOrganization.name] : [], icon: React.createElement("span", { className: 'org-icon' },
                React.createElement("i", { className: 'fas fa-building' }),
                "\u00A0"), alphabetize: true, hideArrow: true })));
};
export default OrgSwitcher;
